export enum CardLayout {
  STANDARD = 'standard',
  COMPACT = 'compact',
}
